import { useOrderCallback } from '../hooks/useOrderCallback';
import { useLoadDiscountData } from '../hooks/useLoadDiscountData';
import { useIsKioskMode } from '../hooks/useIsKioskMode';
import { useEffect, useState } from 'react';
import {
  addCallbacks,
  PriceTableArticle,
  removeCallbacks,
  useAllArticlesAndPrices,
  useConfiguration,
} from '@k3/core';
import { useDealerTheme } from '../hooks/useDealerTheme';
import { useGeneralContext } from '../store/generalContext';
import { Dialog, DialogContent, Typography } from '@mui/material';
import { getDiscountInformation } from '../store/discountContext';

export const PermanentMount = () => () => {
  useOrderCallback();
  useLoadDiscountData();
  const kiosk = useIsKioskMode();
  const dealerStyles = useDealerTheme();
  const { setDealerStyles } = useGeneralContext();

  useEffect(() => {
    if (kiosk) {
      addCallbacks({
        openPdf: () => {
          console.warn('supressing download in kiosk mode');
        },
      });
    } else {
      removeCallbacks(['openPdf']);
    }
  }, [kiosk]);

  useEffect(() => {
    setDealerStyles(dealerStyles);
  }, [dealerStyles]);

  return <ArticleOverview />;
};

export const ArticleOverview = () => {
  const [viewArticles, setViewArticles] = useState<boolean>(false);
  useEffect(() => {
    if (
      new URLSearchParams(window.location.search).get('viewArticles') === 'true'
    ) {
      setViewArticles(true);
    }
  }, []);

  if (viewArticles)
    return <ArticleModal close={() => setViewArticles(false)} />;
  return null;
};

export const ArticleModal = ({ close }: { close: () => void }) => {
  const cfg = useConfiguration();
  const price = cfg?.price ?? 0;
  const bom = useAllArticlesAndPrices();
  const discount = (cfg?.json as Record<string, any>)?.discount
    ?.discountPercentage;
  const discountInfo = getDiscountInformation(price, discount);
  return (
    <Dialog open={true} maxWidth="lg" fullWidth onClose={close}>
      <DialogContent>
        <PriceTableArticle dense={false} bom={bom} showPrice={true} />
        {/* TODO: Muss der Text auch hinsichtlich der neuen Ausweisung der Rabatte geändert werden? */}
        <Typography>
          Die hier aufgeführten Preise sind die Basispreise. Der Kunde hat die
          Konfiguration zu einem Basispreis von {discountInfo.fullPrice}€ mit{' '}
          {discountInfo.discountPercent}% Rabatt gekauft. Der rabattierte Preis
          beträgt damit {discountInfo.discountedPrice}€.
        </Typography>
      </DialogContent>
    </Dialog>
  );
};
